export class DefaultProductSurfaceServiceConfig {
    constructor(requestor) {
        this.requestor = requestor;
    }
    get baseUrl() {
        return "https://surfaces.products.vpsvc.com";
    }
}
//# sourceMappingURL=ProductSurfaceServiceConfig.js.map